// TODO refactor into smaller function units

let $TRIGGER;

// VIMEO querystring options
const options = [
  'autoplay=1', //
  'title=0',
  'byline=0',
  'portrait=0'
].join('&');

// VIMEO iframe attributes
const attributes = [
  'width="640"',
  'height="360"',
  'frameborder="0"',
  'webkitallowfullscreen',
  'mozallowfullscreen',
  'allowfullscreen'
].join(' ');

function getVimeoEmded(id) {
  return `
    <div class="ps-video__frame">
      <iframe src="https://player.vimeo.com/video/${id}?${options}" ${attributes}></iframe>
    </div>`;
}

function getOverlayHtml(inner) {
  const doc = document;
  const body = doc.body;
  const html = `<div class="ps-overlay__inner">${inner}</div>`;

  // create the child node
  const div = doc.createElement('div');
  div.innerHTML = html;
  div.className = 'ps-overlay';

  // augment the DOM
  body.appendChild(div);

  // return the destroy method
  return () => {
    body.removeChild(div);
  };
}

function toggleAttribute(e) {
  const self = e.target;
  const className = self.className;

  if (!/poster$/i.test(className)) return;
  e.preventDefault();
  e.stopImmediatePropagation();


  // derive the video ID, render iFrame and inject into DOM
  const href = (self && self.href) || '';
  const matches = href.match(/[^\/]+$/) || [null];
  const id = matches[0];

  // VIMEO id integrity check
  if (!/^\d+$/.test(id)) {
    console.error('VIMEO video ID is not valid (%s)', id);
    return false;
  }

  const iframe = getVimeoEmded(id);
  const destroy = getOverlayHtml(iframe);

  // bind an event to close the ovelay
  document.querySelector('.ps-overlay').addEventListener('click', destroy);
}

export default class Video {
  constructor($el, opts) {
    $TRIGGER = $el;
  }

  init() {
    $TRIGGER.addEventListener('click', toggleAttribute);
  }
}



// WEBPACK FOOTER //
// ./js/modules/Video.js